import React,{useState,useEffect} from 'react'
import {
  Layout,
} from "antd";
import { useNavigate } from "react-router-dom";
import UsersList from "./UsersList";
import { getData } from "../../resources/utils";
import  viewIcon  from "../../Assets/Images/view.webp";
import { type } from '@testing-library/user-event/dist/type';
const { Content } = Layout;

const AdminPanel = () => {

     const navigate = useNavigate()

      const [pendingUsers, setPendingUsers] = useState([]);
      const [approvedUsers, setApprovedUsers] = useState([]);
      const [rejectedUsers, setRejectedUsers] = useState([]);
      const userId = localStorage.getItem("user_id");
      const [updateUserList, setUpdateUserList] = useState(false);

        const updateUserListData = () => {
        setUpdateUserList(!updateUserList);
      }

       useEffect(() => {
        const getUserList = async () => {
          try {
            const [pendingUserData, approvedUserData, rejectedUserData] = await Promise.all([
              getData("agribhumi", "users_list", { status: 0, type:'list',admin_id:userId }, null),
              getData("agribhumi", "users_list", { status: 1, type:'list',admin_id:userId }, null),
              getData("agribhumi", "users_list", { status: 2, type:'list',admin_id:userId }, null)
            ]);

            let pendingUserList = pendingUserData?.data?.data?.map((user) => {
              return {
                id: user?.id,
                name: user?.name,
                mobileNo: user?.mobile_number,
                email: user?.email,
                department: user?.department ?? "",
                designation: user?.designation ?? "",
                viewAccess: viewIcon,
                status: Number(user?.user_status) === 0 ? "Inactive" : 'Active',
                requested_on:user?.updated_on,
                is_admin: Number(user?.user_type) === 1 ? "Admin" : "User" 
              };
            });
            setPendingUsers(pendingUserList);
  
  
            let rejectedUserList = rejectedUserData?.data?.data?.map((user) => {
              return {
                id: user.id,
                name: user.name,
                mobileNo: user.mobile_number,
                email: user.email,
                department: user.department ?? "",
                designation: user.designation ?? "",
                viewAccess: viewIcon,
                status: Number(user?.user_status) === 0 ? "Inactive" : 'Active',
                rejected_on:user?.updated_on,
                is_admin: Number(user?.user_type) === 1 ? "Admin" : "User" 
                
              };
            });
            setRejectedUsers(rejectedUserList);
        
            let approvedUserList = approvedUserData?.data?.data?.map((user) => {
              return {
                id: user?.id,
                name: user?.name,
                mobileNo: user?.mobile_number,
                email: user?.email,
                logins_count: user?.login_count,
                department: user?.department ?? "",
                designation: user?.designation ?? "",
                viewAccess: viewIcon,
                status: Number(user?.user_status) === 0 ? "Inactive" : 'Active',
                approved_on:user?.updated_on,
                is_admin: Number(user?.user_type) === 1 ? "Admin" : "User"         
                   };
            });
            setApprovedUsers(approvedUserList);
          } catch (error) {
            if(error?.status ===403){
              localStorage.clear()
              navigate("/");
;            }
          }

        }
          
         
        getUserList();
      }, [updateUserList]);
  return (
    
<div className="bg-[#3D434B] min-h-[95vh] w-full relative z-0">
  <div className="">

    <div className=" text-center w-[92%] mx-auto p-[2%]">
      <p className="text-[60px] text-white font-bold">
       Agribhumi Admin Page
      </p>
    </div>

    <div>
      <UsersList 
        data={pendingUsers}
        approvedUserListData={approvedUsers}
        updateUserListData={updateUserListData}
        rejectedUserListData={rejectedUsers}
      />
    </div>

  </div>
</div>

  )
}

export default AdminPanel;